import * as React from "react";
import {useTranslation} from "react-i18next";
import {Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import {ExternalApiAllowedIp, ExternalApiClient} from "../../../../model/ExternalApiClient";
import {useCodeBookDetailContextNew} from "../../../../raal_components/controller/CodeBookDetail";

/**
 * Inline editor pro pole "allowedIps" v rámci ExternalApiClientForm.
 * Aktivní jen když ipAccessMode = WHITELIST.
 */
export const ExternalApiAllowedIpsEditor: React.FC = () => {
    const {t} = useTranslation();
    const ctx = useCodeBookDetailContextNew<ExternalApiClient>();
    const data = ctx?.data;
    const ips: ExternalApiAllowedIp[] = Array.isArray(data?.allowedIps) ? data!.allowedIps : [];
    const enabled = data?.ipAccessMode === "WHITELIST";

    if (!enabled) {
        return (
            <div style={{opacity: 0.6}}>
                <h4>{t("ExternalApiClient.AllowedIps")}</h4>
                <p>{t("ExternalApiClient.AllowedIpsDisabled")}</p>
            </div>
        );
    }

    const replace = (next: ExternalApiAllowedIp[]) => {
        if (!data) return;
        ctx.setData({...data, allowedIps: next} as ExternalApiClient);
    };

    const updateRow = (idx: number, field: keyof ExternalApiAllowedIp, val: string) => {
        const next = [...ips];
        const row = {...(next[idx] ?? new ExternalApiAllowedIp())};
        (row as any)[field] = val;
        next[idx] = row;
        replace(next);
    };

    const addRow = () => replace([...ips, new ExternalApiAllowedIp()]);
    const deleteRow = (idx: number) => replace(ips.filter((_, i) => i !== idx));

    return (
        <div>
            <h4>{t("ExternalApiClient.AllowedIps")}</h4>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{t("ExternalApiClient.ipOrCidr")}</TableCell>
                        <TableCell>{t("ExternalApiClient.ipDescription")}</TableCell>
                        <TableCell width={48}/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ips.map((o, idx) => (
                        <TableRow key={idx}>
                            <TableCell>
                                <TextField
                                    value={o.ipOrCidr ?? ""}
                                    onChange={e => updateRow(idx, "ipOrCidr", e.target.value)}
                                    inputProps={{maxLength: 64}}
                                    placeholder="10.0.0.0/8"
                                    fullWidth
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={o.description ?? ""}
                                    onChange={e => updateRow(idx, "description", e.target.value)}
                                    inputProps={{maxLength: 255}}
                                    fullWidth
                                />
                            </TableCell>
                            <TableCell>
                                <IconButton size="small" onClick={() => deleteRow(idx)} aria-label={t("Default.Remove")}>
                                    <DeleteIcon fontSize="small"/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button onClick={addRow} startIcon={<AddIcon/>} size="small" style={{marginTop: 8}}>
                {t("ExternalApiClient.AddAllowedIp")}
            </Button>
        </div>
    );
};
